
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.516 0C4.404 0 3.484.92 3.484 2.032v3.774H2.032C.92 5.806 0 6.726 0 7.84v8.129C0 17.08.92 18 2.032 18h10.452c1.112 0 2.032-.92 2.032-2.032v-3.774h1.452c1.112 0 2.032-.92 2.032-2.033V4.355c0-1.112-.92-2.032-2.032-2.032h-4.285L9.617.254A.871.871 0 009 0zm0 1.742H8.64l2.067 2.068a.871.871 0 00.617.255h4.645c.17 0 .29.12.29.29v5.806c0 .171-.12.29-.29.29H5.516a.278.278 0 01-.29-.29V2.032c0-.17.12-.29.29-.29zM2.032 7.548h1.452v2.613a.871.871 0 00.004.084.871.871 0 00.012.084.871.871 0 00.02.082.871.871 0 00.03.08.871.871 0 00.127.217.871.871 0 00.065.07c.206.566.588.947 1.153 1.155l.002.002a.871.871 0 00.127.107.871.871 0 00.073.043.871.871 0 00.074.038.871.871 0 00.161.05.871.871 0 00.184.02h7.258v3.775c0 .17-.12.29-.29.29H2.032c-.17 0-.29-.12-.29-.29v-8.13c0-.17.12-.29.29-.29z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    